import React, { FC } from 'react'
import { MilestoneHighlightProps } from './MilestoneHighlight.types'
import './MilestoneHighlight.scss'
import { sanitizeHTML } from '../../utils/common-utils'

export const MilestoneHighlight: FC<MilestoneHighlightProps> = props => {
  const {
    heading,
    subheading,
    founderImageSrc,
    founderImageAlt,
    founderDescription,
    milestoneImageSrc,
    milestoneImageAlt,
    qrCodeSrc,
    qrCodeAlt,
    qrCodeDescription,
    backgroundImage,
  } = props.content

  return (
    <section
      className='milestone-highlight u-paddingVert64 u-flex u-flexJustifyCenter'
      style={{ background: `url(${backgroundImage})` }}>
      <div className='u-sizeConstrained u-flex u-flexJustifyCenter'>
        <div className='u-size8of12'>
          <h2 className='u-md-textSizeMsrp6 u-sm-textSizeMsrp4 u-textSizeMsrp8 u-textColorWhite u-textSecondary u-textLight u-textCenter u-marginBottom16'>
            {heading}
          </h2>
          <h3 className='u-textSizeMsrp4 u-md-textSizeMsrp4 u-sm-textSizeMsrp3 u-textColorWhite u-textItalic u-textSecondary u-textCenter u-marginBottom48'>
            {subheading}
          </h3>
          <div className='u-flex u-flexJustifyCenter u-flexAlignItemsCenter'>
            {founderImageSrc && (
              <img
                className='confounder-image u-marginRight20'
                src={founderImageSrc}
                alt={founderImageAlt}
              />
            )}
            <div
              className='u-marginBottom20'
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(founderDescription),
              }}></div>
          </div>
          <div className='celebration-card u-flex u-flexJustifyCenter u-marginTop20 u-marginBottom48'>
            <img src={milestoneImageSrc} alt={milestoneImageAlt} />
          </div>
          <div className='u-flex u-flexJustifyCenter u-flexAlignItemsCenter qr-section'>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(qrCodeDescription),
              }}></div>
            {qrCodeSrc && <img className='qr-image' src={qrCodeSrc} alt={qrCodeAlt} />}
          </div>
        </div>
      </div>
    </section>
  )
}
